<template>
  <div class="mine-index">
    <div class="pat-info">
      <div class="avatar"><img :src="userInfo.avatar" alt=""></div>
      <div class="info">
        <div class="name">{{patientInfo.username}}</div>
        <div class="title">{{patientInfo.gender | genderFilter}} 丨 {{patientInfo.birthday | ageFilter}}</div>
        <div class="id">ID: {{patientInfo.display_pat_id}}</div>
      </div>
    </div>
    <div class="mine-menu">
      <div class="menu-section">
        <router-link to="/public/test-code" tag="div" class="menu-item"  v-if="userInfo.user_id==10036">
          <div class="menu-icon"><icon icon-class="nav-profile"></icon></div>
          <div class="menu-text">
            <span>测试页面</span>
            <icon icon-class="arrow"></icon>
          </div>
        </router-link>
        <router-link to="/patient/doctor" tag="div" class="menu-item">
          <div class="menu-icon"><icon icon-class="nav-profile"></icon></div>
          <div class="menu-text">
            <span>我的医生</span>
            <icon icon-class="arrow"></icon>
          </div>
        </router-link>
        <router-link to="/patient/my-medical-record" tag="div" class="menu-item">
          <div class="menu-icon"><icon icon-class="nav-record"></icon></div>
          <div class="menu-text">
            <span>我的病历</span>
            <icon icon-class="arrow"></icon>
          </div>
        </router-link>
        <router-link to="/patient/order" tag="div" class="menu-item">
          <div class="menu-icon"><icon icon-class="nav-order"></icon></div>
          <div class="menu-text">
            <span>我的订单</span>
            <icon icon-class="arrow"></icon>
          </div>
        </router-link>
        <router-link to="/patient/address/list" tag="div" class="menu-item">
          <div class="menu-icon"><icon icon-class="nav-address"></icon></div>
          <div class="menu-text">
            <span>我的地址管理</span>
            <icon icon-class="arrow"></icon>
          </div>
        </router-link>
        <router-link to="/patient/coupon" tag="div" class="menu-item" >
          <div class="menu-icon"><img style="width: 17px;margin-left: 3px;margin-top: 3px;" src="@/assets/images/icons/kaquan.png" /></div>
          <div class="menu-text">
            <span>我的诊疗券</span>
            <icon icon-class="arrow"></icon>
          </div>
        </router-link>
        <router-link to="/patient/appoint" tag="div" class="menu-item" >
          <div class="menu-icon"><img style="width: 17px;margin-left: 3px;margin-top: 3px;" src="@/assets/images/icons/icon-appoint.png" /></div>
          <div class="menu-text">
            <span>我的加号条</span>
            <icon icon-class="arrow"></icon>
          </div>
        </router-link>
      </div>
      <div class="menu-section">
        <router-link to="/patient/statement" tag="div" class="menu-item">
          <div class="menu-icon"><icon icon-class="nav-law-tip"></icon></div>
          <div class="menu-text">
            <span>法律声明与隐私条款</span>
            <icon icon-class="arrow"></icon>
          </div>
        </router-link>
        <a :href="`tel:${serviceNumber}`" class="menu-item">
          <div class="menu-icon"><icon icon-class="nav-service"></icon></div>
          <div class="menu-text">
            <span>联系客服</span>
            <icon icon-class="arrow"></icon>
          </div>
        </a>
      </div>

    </div>
  </div>
</template>

<style lang="less" scoped>
  .mine-index{
    .pat-info{
      position: relative;
      padding: 34px 20px;
      background: url('@{images-path}/user-bg.png') no-repeat center center;
      background-size: cover;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .avatar{
        width: 56px;
        height: 56px;
        border-radius: 50%;
        border: 2px solid #FFF;
        overflow: hidden;
        flex-shrink: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        box-shadow: 0px 2px 4px 0px rgba(54,104,166,0.2);
        img{
          width: 100%;
        }
      }
      .info{
        margin-left: 16px;
        color: #333;
        font-weight: bold;
        .name{
          font-size: 20px;
          line-height: 20px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          span{
            margin-left: 12px;
            padding: 0 6px;
            height: 18px;
            border-radius: 9px;
            color: @xile;
            line-height: 18px;
            font-weight: normal;
            font-size: 14px;
            background: rgba(255, 255, 255, .7);
            white-space: nowrap;
          }
        }
        .title{
          font-size: 14px;
          line-height: 14px;
          margin-top: 14px;
        }
      }
      .id{
        position: absolute;
        bottom: 0;
        right: 16px;
        height: 28px;
        line-height: 28px;
        padding: 0 8px;
        color: #FFF;
        font-size: 14px;
        border-radius: 10px 10px 0 0;
        background: linear-gradient(270deg,rgba(77,140,217,1) 0%,rgba(54,104,166,1) 100%);
      }
    }
    .mine-menu{
      background: #FFF;
      border-radius: 6px 6px 0 0;
      overflow: hidden;
      .menu-section:not(:first-child){
        border-top: 8px solid #EEE;
      }
      .menu-item{
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 50px;
        padding-left: 20px;
        transition: all .1s;
        &:active{
          background: #F9F9F9;
        }
        .menu-icon{
          width: 22px;
          height: 22px;
          flex-shrink: 0;
          svg{
            font-size: 22px;
            color: @xile;
          }
        }
        .menu-text{
          flex: 1;
          height: 50px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-bottom: 1px solid #EEE;
          margin-left: 12px;
          padding-right: 20px;
          span{
            font-size: 15px;
            color: @black;
          }
          svg{
            font-size: 14px;
            color: #CCC;
          }
        }
      }
    }
  }
</style>

<script type="text/javascript">
  export default {
    data() {
      return {
        patientInfo: {},
      }
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      },
      serviceNumber() {
        return this.$store.state.servicePhone;
      }
    },
    created() {
      this.$root.post('/getPatientDetail', {
        pat_id: this.userInfo.user_id,
      }).then(data => {
        this.patientInfo = data;
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Patient/Index/mine.vue